import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  children?: React.ReactNode;
};

function lightingPath(href: string) {
  if (!href.startsWith('/')) return href;
  if (href === '/') return '/lighting';
  if (href.startsWith('/lighting')) return href;
  return `/lighting${href}`;
}

export default function Link({ href, children, ...props }: Props) {
  if (/^(https?:|mailto:|tel:|#)/i.test(href)) {
    return <a href={href} {...props}>{children}</a>;
  }
  return <RouterLink to={lightingPath(href)} {...props}>{children}</RouterLink>;
}
